import { detailFieldStyles } from '@v2/components';

export const styles = {
  container:
    'tw-w-4/5 tw-h-full tw-flex tw-flex-col tw-bg-white tw-rounded tw-border tw-border-neutral-200 tw-shadow-sm tw-overflow-hidden tw-transition-all tw-duration-300 tw-ease-in-out',
  header:
    'tw-flex tw-items-center tw-justify-between tw-gap-3 tw-px-4 tw-py-3 tw-border-b tw-border-neutral-200 tw-bg-neutral-50 tw-flex-shrink-0',
  titleGroup: 'tw-flex tw-min-w-0 tw-flex-1 tw-flex-wrap tw-items-baseline tw-gap-x-2 tw-gap-y-0',
  title: 'tw-text-lg tw-font-semibold tw-text-neutral-800 tw-m-0',
  subtitle: 'tw-text-sm tw-font-normal tw-text-neutral-500',
  headerActions: 'tw-flex tw-items-center tw-gap-1 tw-flex-shrink-0',
  closeIcon: 'tw-w-5 tw-h-5',
  content: 'tw-p-4 tw-flex-1 tw-overflow-y-auto',
  fieldContainer: detailFieldStyles.fieldContainer,
  stateContainer: 'tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-12 tw-text-center',
  errorIcon: 'tw-text-4xl tw-text-red-400 tw-mb-3',
  stateMessage: 'tw-text-neutral-600 tw-mb-4',
  actionsContainer: 'tw-mt-6 tw-pt-4 tw-border-t tw-border-neutral-100',
};
